var _style, _polygon, _polygon2, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueRectangular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 53.4",
    style: {
      enableBackground: "new 0 0 24 53.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.529,
    y1: 14.1845,
    x2: 20.1208,
    y2: 29.6414
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.218,
    style: {
      stopColor: "#22298F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7284,
    style: {
      stopColor: "#0B73D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0096EE"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1.4,0 24,33 8.1,30.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.107,
    y1: 33.1146,
    x2: 13.9288,
    y2: 48.1937
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0096EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03170407,
    style: {
      stopColor: "#009DEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1956,
    style: {
      stopColor: "#00BBF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3681,
    style: {
      stopColor: "#00D3F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5508,
    style: {
      stopColor: "#00E4F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7507,
    style: {
      stopColor: "#00EEF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F1F7"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "24,33 8.1,30.6 0,53.4 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.7404,
    y1: 11.794,
    x2: 4.2585,
    y2: 43.0866
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.218,
    style: {
      stopColor: "#3952AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5823,
    style: {
      stopColor: "#1D73CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0096EE"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1.4,0 8.1,30.6 0,53.4 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueRectangular);
export default __webpack_public_path__ + "static/media/blue-rectangular.3c3449b329c40dd04938818d159595e3.svg";
export { ForwardRef as ReactComponent };